import React, { lazy } from 'react';
const ReleasesDashboard = lazy(() => import('containers/Releases/ReleasesDashboard'));
function ReleasesRouts() {
    return React.createElement(ReleasesDashboard, null);
}
export default ReleasesRouts;
